import { IFrameConfig } from "./iframe/iFrameConfig";
import CategoryPageConfig from "./category-page";

export const MiscConfigs = [IFrameConfig, CategoryPageConfig];
